import React from 'react';
import cn from 'bem-cn-lite';
import {type OperationMonitoringTabProps} from '../../../../../UIFactory';
import {uiSettings} from '../../../../../config/ui-settings';
import Icon from '../../../../../components/Icon/Icon';
import Link from '../../../../../containers/Link/Link';
import {YTErrorBlock} from '../../../../../containers/Block/Block';
import {MetaTable, type MetaTableItem} from '@ytsaurus/components';
import {OperationPool} from '../../../../../components/OperationPool/OperationPool';
import {operationMonitoringUrl} from '../../../../../utils/operations/detail';
import i18n from './i18n';

const block = cn('operation-detail-monitor-links');

function OperationDetailsMonitorLinks(props: OperationMonitoringTabProps) {
    const {operation, cluster} = props;
    const {pools = []} = operation ?? {};
    const {operationsMonitoring: {urlTemplate, title} = {}} = uiSettings;

    if (!urlTemplate) {
        return <YTErrorBlock message={i18n('alert_url-template-not-defined')} />;
    }

    const items: Array<MetaTableItem> = pools.map(({pool, tree, slotIndex}, index) => {
        return {
            key: String(index),
            label: (<OperationPool cluster={cluster} pool={{pool, tree}} />) as any,
            value: (
                <Link
                    url={operationMonitoringUrl({
                        cluster,
                        operation,
                        pool,
                        tree,
                        slotIndex,
                        urlTemplate,
                    })}
                >
                    {title ?? i18n('action_monitoring')} <Icon awesome="external-link" />
                </Link>
            ),
        };
    });

    return (
        <div className={block()}>
            <MetaTable items={items} />
        </div>
    );
}

export default React.memo(OperationDetailsMonitorLinks);
